import routes from '@/constants/routes';
import { ActionName, ActionTitle } from '../enums';
import BaseRedirectAction from './base-redirect.action';

export default class ViewListingAction extends BaseRedirectAction {
  name = ActionName.ViewListing;
  title = ActionTitle.ViewListing;

  // eslint-disable-next-line class-methods-use-this
  getLink({ listingId }) {
    return `${routes.listings}/${listingId}`;
  }
}
